import {ActionTree} from "vuex";
import {PortalTimelineWidgetState} from "@/apps/PortalTimelineWidget/models/portal-timeline-widget-state";

export default <ActionTree<PortalTimelineWidgetState, PortalTimelineWidgetState>>{
    async init(context, props) {
        await context.commit('setItems', props.items);
        await context.commit('setLabels', props.labels);
        await context.commit('setSelectedItem', 0);
    }
}
